import printserverWindows from './printserver-windows.md?raw';
import printserverCups from './printserver-cups.md?raw';
import agentWindows from './agent-windows.md?raw';
import agentLinux from './agent-linux.md?raw';
import agentContainer from './agent-container.md?raw';
import entraScim from './entra-scim.md?raw';
import entraSso from './entra-sso.md?raw';
import entraSsoNycelogic from './entra-sso-nycelogic.md?raw';
import workserverAuth from './workserver-auth.md?raw';
import buddyAddin from './buddy-addin.md?raw';

/** Installation guides (decision 6): Markdown in the repo, `{{key}}` filled from the wizard's values (URL query). */
export interface Guide {
  id: string;
  title: string;
  audience: string;
  text: string;
}

export const GUIDES: Guide[] = [
  {
    id: 'printserver-windows',
    title: 'Print server on Windows',
    audience: 'Site IT',
    text: printserverWindows,
  },
  {
    id: 'printserver-cups',
    title: 'Print server with CUPS (Linux / macOS)',
    audience: 'Site IT',
    text: printserverCups,
  },
  { id: 'agent-windows', title: 'Automation agent on Windows', audience: 'Site IT', text: agentWindows },
  { id: 'agent-linux', title: 'Automation agent on Linux', audience: 'Site IT', text: agentLinux },
  {
    id: 'agent-container',
    title: 'Automation agent in a container',
    audience: 'Site IT',
    text: agentContainer,
  },
  {
    id: 'entra-scim',
    title: 'User provisioning from Entra ID (SCIM)',
    audience: 'Customer Entra admin',
    text: entraScim,
  },
  {
    id: 'entra-sso',
    title: 'Sign in with Microsoft Entra ID — AUTH tenants (SAML)',
    audience: 'Customer Entra admin',
    text: entraSso,
  },
  {
    id: 'entra-sso-nycelogic',
    title: 'Sign in with Microsoft Entra ID — nyce.logic WMS (WorkServer)',
    audience: 'Customer Entra admin / NYCE',
    text: entraSsoNycelogic,
  },
  { id: 'workserver-auth', title: 'WorkServer on AUTH', audience: 'NYCE operations', text: workserverAuth },
  {
    id: 'buddy-addin',
    title: 'nyceBuddy in the client and over MCP',
    audience: 'Customer / NYCE',
    text: buddyAddin,
  },
];

export const guideById = (id: string) => GUIDES.find((g) => g.id === id);

/** Link to a guide with its placeholders filled (`/onboarding/guides/<id>?k=v`). */
export const guidePath = (id: string, values: Record<string, string | null | undefined> = {}) => {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(values)) if (v) q.set(k, v);
  const s = q.toString();
  return `/onboarding/guides/${id}${s ? `?${s}` : ''}`;
};
